export default {"src":"/_next/static/media/sub_in.ca25e196.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};